import React, { useEffect, useState } from 'react';
import _ from 'lodash';
// @ts-ignore
import { Button, Loader } from 'arag-ui-lib';
import { useFormikContext } from 'formik';
import claimBankDetailsQuestionCodes from '../../utils/constants/claimBankDetailsQuestionsCodes';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';
import { ObjectOfAny, QuestionSchema } from '../../reducers/types';
import GenericFormWithChildQuestions from '../genericFormWithChildrenQuestions/genericFormWithChildQuestion';
import GenericParentQuestion from '../genericFormWithChildrenQuestions/genericParentQuestion';
import { TabButton, TabWrapper } from '../../hosc/modals/modals';
import { useTranslation } from 'react-i18next';

type ClaimBankDetailsFormProps = {
    questions: ObjectOfAny;
    updatingClaimBankAccount: boolean;
    initialValues: ObjectOfAny;
    bankDetailsAnswers: ObjectOfAny;
    setDisabledSubmitButton: (b: boolean) => any;
    disabledSubmitButton: boolean;
};

const ClaimBankDetailsForm = (
    props: ClaimBankDetailsFormProps,
): JSX.Element => {
    const {
        questions,
        updatingClaimBankAccount,
        initialValues,
        bankDetailsAnswers,
        setDisabledSubmitButton,
        disabledSubmitButton,
    } = props;
    const { t } = useTranslation();
    const { values, setValues }: any = useFormikContext();
    const [areValuesCleared, setValuesCleared] = useState<boolean>(false);

    useEffect(() => {
        setDisabledSubmitButton(_.isEqual(initialValues, values));
        if (!_.isEqual(initialValues, values) && !areValuesCleared) {
            setValues({
                ...GENERAL_FUNCTIONS.objectKeepDiffsAndClearSameValuesForBankDetails(
                    values,
                    initialValues,
                ),
                [claimBankDetailsQuestionCodes.bankAccountType]:
                    values[claimBankDetailsQuestionCodes.bankAccountType],
            });
            setValuesCleared(true);
        }
    }, [values, initialValues, areValuesCleared]);

    return (
        <div className={'row'}>
            <GenericFormWithChildQuestions>
                {questions?.questions?.map(
                    (
                        question: QuestionSchema | any,
                        index: number,
                        accQuestions: QuestionSchema[],
                    ) => {
                        if (question.isParent) {
                            return (
                                <GenericFormWithChildQuestions.ParentElement
                                    key={question.id}
                                >
                                    <>
                                        <GenericParentQuestion.Form
                                            index={index}
                                            key={question.id}
                                            question={question}
                                            accQuestions={accQuestions}
                                            questionTypes={
                                                questions?.questionTypes as ObjectOfAny
                                            }
                                            notUseFieldValidator={false}
                                            defaultLabelSize={'col-sm-12'}
                                            defaultInputSize={'col-sm-12'}
                                        />
                                    </>
                                </GenericFormWithChildQuestions.ParentElement>
                            );
                        } else {
                            return (
                                <GenericFormWithChildQuestions.ParentElement
                                    key={question.id}
                                >
                                    <>
                                        <GenericFormWithChildQuestions.ChildrenElement
                                            key={question.id}
                                            question={question}
                                            questions={questions?.questions}
                                            questionTypes={
                                                questions?.questionTypes
                                            }
                                            notUseFieldValidator={false}
                                            defaultLabelSize={'col-sm-12'}
                                            defaultInputSize={'col-sm-12'}
                                        />
                                    </>
                                </GenericFormWithChildQuestions.ParentElement>
                            );
                        }
                    },
                )}
                <GenericFormWithChildQuestions.SubmitForm>
                    <TabWrapper>
                        <TabButton>
                            <Button
                                variant="primary"
                                label={
                                    bankDetailsAnswers &&
                                    bankDetailsAnswers.length > 0
                                        ? 'Update Bank Details'
                                        : 'Submit Bank Details'
                                }
                                type={'submit'}
                                disabled={
                                    disabledSubmitButton ||
                                    updatingClaimBankAccount
                                }
                            />
                            {updatingClaimBankAccount && (
                                <Loader
                                    variant="inline"
                                    label={t('updating')}
                                />
                            )}
                        </TabButton>
                    </TabWrapper>
                </GenericFormWithChildQuestions.SubmitForm>
            </GenericFormWithChildQuestions>
        </div>
    );
};

export default ClaimBankDetailsForm;
